import { useEffect, useState } from "react";

import { useStore } from "../../_v2/stores/AppStore";

import { getGoodsInStats } from "../../_v2/modules/goods_in/services/goodsIn.requests";
import { getOrdersStats } from "../../_v2/modules/orders/services/order.requests";

//TODO: Eliminar este archivo cuando se hagan las notificaciones al 100%.
export const useNotifications = () => {
  const store = useStore();
  const account = store.user.loggedInUser?.account;

  const [arrayNotifications, setArrayNotifications] = useState(null);
  const [hasGodsIns, setHasGodsIns] = useState(null);
  const [hasOrders, setHasOrders] = useState(null);

  const isOperating = hasOrders && hasGodsIns;
  const isOnboarding = account?.isWaitingOnboarding;

  /* get orders stats */
  useEffect(() => {
    const isAdmin = store.user.loggedInUser?.isAdmin;

    if (!isAdmin && account) {
      const filters = {
        archived: true,
        seller_id: account.id,
        type: "variant",
      };

      getOrdersStats(filters).then((res) => {
        setHasOrders(res.results.total.exists);
      });
    }
  }, [account, store.user.loggedInUser]);

  /* get goodsIn stats */
  useEffect(() => {
    const isAdmin = store.user.loggedInUser?.isAdmin;

    if (!isAdmin && account) {
      const filters = {
        archived: true,
        seller_id: account.id,
      };

      getGoodsInStats(filters).then((res) => {
        setHasGodsIns(res.results.total.exists);
      });
    }
  }, [account, store.user.loggedInUser]);

  /* notifications list */
  useEffect(() => {
    if (hasGodsIns !== null && hasOrders !== null) {
      setArrayNotifications([
        {
          category: "Novedades",
          id: "notifications--checkout-date",
          name: "checkoutDate",
          text:
            "En Tiendanube y Shopify, los compradores podrán elegirla en el checkout. Para activarlo, comunícate con Soporte.",
          title: "¡Nueva función para elegir fecha!",
          type: "info",
          visible: account?.isFullfilment && account.active,
          href:
            "https://sm.pemres.net/preview/link/ZmDmhDRWIzJoNpGjxsdxGHXCGTbyAERLxPF",
          push_at: new Date(2025, 6, 29, 15, 30, 0),
        },
        {
          category: "Ship tips",
          href:
            "https://shipnow.notion.site/Activaci-n-de-cuenta-d48fdffcc1fc47a8860289a8fa8076e1",
          id: "notifications--shipTips-btn-activateAccount",
          name: "activateAccount",
          text: "Lee nuestra guía y aprende cómo hacerlo.",
          title: "¡Aún no activaste tu cuenta!",
          type: "info",
          visible: isOnboarding,
          push_at: new Date(2023, 0, 5, 10, 45, 0),
        },
        {
          category: "Ship tips",
          href:
            "https://shipnow.notion.site/C-mo-empezar-a-operar-9d8295cc6115423889859c3745f4d4fe",
          id: "notifications--shipTips-btn-operationAccount",
          name: "operationAccount",
          text: "Conoce cómo dar tus primeros pasos.",
          title: "¡Ya puedes empezar a operar!",
          type: "info",
          visible: account?.active && !isOperating,
          push_at: new Date(2023, 0, 5, 10, 45, 0),
        },
        {
          category: "Ship tips",
          href:
            "https://shipnow.notion.site/C-mo-etiquetar-un-pedido-para-una-recolecci-n-aed3291366d24d2c9a22380fc53ca8f0",
          id: "notifications--shipTips-btn-prepareProductsCD",
          name: "prepareProductsCD",
          text: "En nuestra guía, te enseñamos cómo hacerlo.",
          title: "¿Sabes cómo preparar tus pedidos?",
          type: "info",
          visible: account?.isCrossdocking && account?.active && !isOperating,
          push_at: new Date(2023, 0, 5, 10, 45, 0),
        },
        {
          category: "Ship tips",
          href:
            "https://shipnow.notion.site/C-mo-etiquetar-una-variante-para-un-ingreso-11278c77f8de480eb3ec3638552acf76",
          id: "notifications--shipTips-btn-prepareProductsFF",
          name: "prepareProductsFF",
          text: "En nuestra guía, te enseñamos cómo hacerlo.",
          title: "¿Sabes cómo preparar tus variantes?",
          type: "info",
          visible: account?.isFullfilment && account.active && !isOperating,
          push_at: new Date(2023, 0, 5, 10, 45, 0),
        },
      ]);
    }
  }, [hasGodsIns, hasOrders]); // eslint-disable-line react-hooks/exhaustive-deps

  return arrayNotifications;
};
